package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.documents.PolicyAcknowledgementDto
import com.evoapps.evoshift.data.dto.documents.StaffDocumentDto
import com.evoapps.evoshift.data.dto.documents.WorkplacePolicyDto
import com.evoapps.evoshift.domain.model.PolicyAcknowledgement
import com.evoapps.evoshift.domain.model.StaffDocument
import com.evoapps.evoshift.domain.model.StaffDocumentType
import com.evoapps.evoshift.domain.model.WorkplacePolicy
import kotlinx.datetime.LocalDate
import kotlin.time.Instant

/** SH-122 documents and policies. Unknown types read as OTHER, unreadable dates as missing. */
object DocumentMapper {
    private fun date(value: String?): LocalDate? = value?.let { runCatching { LocalDate.parse(it.take(10)) }.getOrNull() }
    private fun instant(value: String?): Instant? = value?.let { runCatching { Instant.parse(it) }.getOrNull() }

    fun toDomain(dto: StaffDocumentDto, id: String, userId: String) = StaffDocument(
        id = id,
        userId = userId,
        workplaceId = dto.workplaceId,
        type = StaffDocumentType.entries.firstOrNull { it.name == dto.type } ?: StaffDocumentType.OTHER,
        fileName = dto.fileName,
        contentType = dto.contentType,
        sizeBytes = dto.sizeBytes.toLong(),
        expiresOn = date(dto.expiresOn),
        uploadedAt = instant(dto.uploadedAt),
        uploadedBy = dto.uploadedBy
    )

    fun toDto(document: StaffDocument) = StaffDocumentDto(
        id = document.id,
        userId = document.userId,
        workplaceId = document.workplaceId,
        type = document.type.name,
        fileName = document.fileName,
        contentType = document.contentType,
        sizeBytes = document.sizeBytes.toInt(),
        expiresOn = document.expiresOn?.toString(),
        uploadedAt = document.uploadedAt?.toString(),
        uploadedBy = document.uploadedBy
    )

    fun toDomain(dto: WorkplacePolicyDto, id: String, workplaceId: String) = WorkplacePolicy(
        id = id,
        workplaceId = workplaceId,
        title = dto.title,
        fileName = dto.fileName,
        sizeBytes = dto.sizeBytes.toLong(),
        publishedAt = instant(dto.publishedAt),
        publishedBy = dto.publishedBy
    )

    fun toDto(policy: WorkplacePolicy) = WorkplacePolicyDto(
        id = policy.id,
        workplaceId = policy.workplaceId,
        title = policy.title,
        fileName = policy.fileName,
        sizeBytes = policy.sizeBytes.toInt(),
        publishedAt = policy.publishedAt?.toString(),
        publishedBy = policy.publishedBy
    )

    /** Null for a confirmation without a readable time (never written by the function). */
    fun toDomain(dto: PolicyAcknowledgementDto, userId: String, workplaceId: String, policyId: String): PolicyAcknowledgement? =
        instant(dto.acknowledgedAt)?.let { PolicyAcknowledgement(policyId, workplaceId, userId, it, dto.displayName) }
}
